package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class FilterSet(
    val id: Long?,
    var name: String?,
    val filterValues: List<FilterSetValue>?
)